import { ApiService } from "./AbstractApiService";
import qs from "qs";
import { IPageModel } from "@/interfaces/iPageModel";
import { IDocuments } from "@/interfaces/iDocument";
import API from "./handlers/base.service";

export class DocumentApi extends ApiService {
  public static getInstance() {
    if (!this.instance) {
      this.instance = new this(`document`);
    }
    return this.instance;
  }
  private static instance: DocumentApi | null;
  public async getDocumentsList(
    queryParams: Record<string, string | number>
  ): Promise<IPageModel<IDocuments>> {
    const params = this.transformDateRangeParams(queryParams ?? {});
    return this.get(``, {
      params,
      paramsSerializer: (p) => qs.stringify(p, { arrayFormat: "comma" }),
    }).then((response) => response.data);
  }
  public transformDateRangeParams(
    params: Record<string, string | number>
  ): Record<string, string | number> {
    if (
      params &&
      params["startDate"] &&
      `${params["startDate"]}`.split(",").length > 1
    ) {
      const dates = `${params["startDate"]}`.split(",");
      params["startDate"] = dates[0];
      params["endDate"] = dates[1];
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { ...rest } = params;
    return rest;
  }
  public async downloadFile(documentId: string, fileName: string) {
    return API.get(`dms/file/download/${documentId}`, {
      responseType: "blob",
      headers: { Accept: "*/*" },
    }).then((response) => {
      const blob = new Blob([response.data], {
        type: fileName.split(".")[1],
      });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = fileName;
      link.click();
      URL.revokeObjectURL(link.href);
    });
  }
  public async generatePDF(documentId: string | number) {
    return API.post(`forms/definitions/pdf/${documentId}`, {}).then(
      (response) => response.data
    );
  }
  public async audioFileList(documentId: string | number) {
    return API.get(
      `dms/fileEntity/file/${documentId}?contentType=audio`,
      {}
    ).then((response) => response.data);
  }
  public async fetchAudioWithMetaData(path: string) {
    return API.get(`dms/file/${path}`, {
      responseType: "arraybuffer",
      headers: { Accept: "*/*" },
    });
  }
}
